import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    sadcat: {
        height: 200
    }
  }));


export const ErrorPage = ({ error }) => {
    const classes = useStyles();
  
    return (
    <div className={classes.root}>
        <Grid container spacing={3}>
            <Grid item xs={12} className={classes.paper}>
                <Typography variant="h3" gutterBottom>Sorry!</Typography>
            </Grid>
            <Grid item xs={12} className={classes.paper}>
                <Typography variant="h5" gutterBottom>{error}</Typography>
            </Grid>
            <Grid item xs={12} className={classes.paper}>
                If interested <a href="https://graniot.com/contacto.html">contact us!</a>
            </Grid>
        </Grid>
    </div>)
}
